<template>
  <div class="contentWrap boxed">
    <div class="d2-section">
      <div class="d2-section__header">
        <h2 class="d2-h2">
          <span class="text_color"> {{ $t("terms") }}</span>
        </h2>
      </div>

      <div class="d2-section__content">
        <span v-if="lang_gamebox == 'slovakia'">
          <terms-slovakia />
        </span>
        <span v-if="lang_gamebox == 'czech'">
          <terms-czech />
        </span>
        <span v-else>
          <terms-english />
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import TermsEnglish from "./TermsEnglish";
import TermsSlovakia from "./TermsSlovakia";
import { mapGetters } from "vuex";
import TermsCzech from "./TermsCzech.vue";

export default {
  computed: mapGetters(["lang_gamebox", "country_gamebox"]),
  components: {
    "terms-english": TermsEnglish,
    "terms-slovakia": TermsSlovakia,
    TermsCzech,
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.privacy_color,
.mobiSection__content,
.mobitxt {
  color: white !important;
}
.mobiFaq {
  margin: 25px 0px;
  .mobitxt {
    margin: 8px 0px;
    padding-left: 25px;
  }
  .mobiTitle {
    padding: 12px;
    background: #f1f1f1;
  }
  li {
    font-size: 1rem;
    line-height: 1.2;
    font-weight: 300;
    margin-bottom: 8px;
  }
}

.ar_layout {
}
</style>


// WEBPACK FOOTER //
// src/components/gamebox/Terms.vue